import React from 'react'
import { Row, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { CustomCol, FormLabels, CustomSelect, CustomText, CustomInputDecimal } from 'src/components'
import {
  isFreeDonationSelectedSelector,
  projectFormIsActiveSelector,
  setProjectFormItemValue,
  currencyListSelector,
  isVintageSelector,
} from 'src/features'
const { Option } = Select

const ProjectFormCurrencySelector: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const currencyList = useAppSelector(currencyListSelector)
  const isActive = useAppSelector(projectFormIsActiveSelector)
  const isFreeDonationSelected = useAppSelector(isFreeDonationSelectedSelector)
  const isVintageSelected = useAppSelector(isVintageSelector)
  const { width } = useWindowSize()
  const isMobile = width < 800

  return (
    <Row>
      <CustomCol>
        <FormLabels
          title={t('Projects.PriceLabel')}
          subtitle={t('Projects.CostLabel')}
        />
      </CustomCol>
      <CustomCol>

        <Row>
          {(!isFreeDonationSelected && !isVintageSelected) && (
            <CustomCol className='mr-2' lg={11}>
              {/* Project Price */}
              <CustomText label={t('Projects.Price')} type='secondary' />
              <CustomInputDecimal
                name='price'
                placeholder={t('Projects.PricePlaceHolder')}
                onChange={(value: number) => {
                  if ((!value || value <= 0) && isActive) {
                    dispatch(setProjectFormItemValue({ key: 'is_active', value: false }))
                  }
                  dispatch(setProjectFormItemValue({ key: 'price', value }))
                }}
                required={isActive}
              />
            </CustomCol>
          )}

          <CustomCol
            lg={(isFreeDonationSelected || isVintageSelected) ? 24 : 12}
            className={!isMobile && 'ml-2'}
          >
            {/* Project Currency */}
            <CustomText label={t('Projects.Currency')} type='secondary' />
            <CustomSelect
              name='currency_token'
              showSearch={false}
              placeholder={t('Projects.currencyPlaceHolder')}
              onChange={(value) => {
                dispatch(setProjectFormItemValue({ key: 'currency_token', value: +value }))
              }}
              required
            >
              {currencyList.map(c => <Option key={c.id} value={c.id}>{c.code}</Option>)}
            </CustomSelect>
          </CustomCol>
        </Row>
      </CustomCol>
    </Row>
  )
}

export default ProjectFormCurrencySelector
